import React, { FC } from "react"
import GatsbyImage, { FluidObject } from "gatsby-image"
import styled from "styled-components"

// components
import Button from "../atoms/Button"

// constants
import { useLocale } from "../../hooks/useLocale"

// styles
import colors from "../../styles/colors"
import mq from "../../styles/breakpoints"
import { fontWeights } from "../../styles/textStyles"
import { fonts } from "../../styles/fonts"

interface Props {
  name: string
  role: string
  image: FluidObject
  heading: string
  description: string
}
const TeamMember: FC<Props> = ({ image, name, role, heading, description }) => {
  const { getLocalizedLink } = useLocale()
  return (
    <TeamMemberSecion>
      <TextSection>
        <Title>{heading}</Title>
        <Paragraph>{description}</Paragraph>
      </TextSection>
      <TeamMemberIntro>
        <TeamMemberBio>
          <TextWrapper>
            <TeamMemberName>{name}</TeamMemberName>
            <TeamMemberDesignation>{role}</TeamMemberDesignation>
          </TextWrapper>
          <ButtonWrapper>
            <StyledButton
              label="Neem contact op"
              href={getLocalizedLink("/contact")}
              fullWidth={true}
            />
          </ButtonWrapper>
        </TeamMemberBio>
        <ImageWrapper>
          <GatsbyImage fluid={image} alt={name} />
        </ImageWrapper>
      </TeamMemberIntro>
    </TeamMemberSecion>
  )
}

export default TeamMember

const TeamMemberSecion = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  ${mq.from.XSM`
    flex-direction: row;
  `}
`

const TextSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const Title = styled.h2`
  font-size: 28px;
  line-height: 36px;
  font-weight: ${fontWeights.bold};
  letter-spacing: -1px;
  color: ${colors.main["200"]};
  margin-bottom: 0px;

  ${mq.from.M`
  font-size: 40px;
  line-height: 52px;
  `}
`
const Paragraph = styled.p`
  font-size: 20px;
  line-height: 32px;
  font-weight: ${fontWeights.regular};
  letter-spacing: -1%;
  color: ${colors.main["200"]};
  margin-bottom: 0px;
`
const TeamMemberIntro = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  border-radius: 32px;
  background-color: ${colors.white};
  overflow: hidden;

  ${mq.from.XSM`
    align-items: center;
    flex-direction: row;
    justify-content: space-evenly;
  `}
`
const TeamMemberBio = styled.div`
  height: 212px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0px 24px;
  gap: 22px;

  ${mq.from.XSM`
    padding: 0px 16px 0px 16px;
    width: max-content;
  `}

  ${mq.from.M`
    width: 389px;
    height: auto;
    padding: 0px 48px;
  `}
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const TeamMemberName = styled.h3`
  font-family: ${fonts.primary};
  font-size: 24px;
  line-height: 34px;
  font-weight: ${fontWeights.bold};
  letter-spacing: -1px;
  color: ${colors.main["100"]};
  margin-bottom: 0px;

  ${mq.from.M`
    font-size: 32px;
    line-height: 40px;
  `}
`
const TeamMemberDesignation = styled.h5`
  font-family: ${fonts.primary};
  font-size: 18px;
  line-height: 26px;
  font-weight: ${fontWeights.medium};
  color: ${colors.main["400"]};
  margin-bottom: 0px;

  ${mq.from.M`
    font-size: 22px;
    line-height: 30px;
  `}
`
const ButtonWrapper = styled.div`
  display: flex;
  gap: 12px;
`
const StyledButton = styled(Button)`
  font-size: 18px;
  line-height: 20px;
  font-weight: ${fontWeights.medium};
  width: 100%;

  ${mq.from.M`
    margin-right: auto;
  `}
`
const ImageWrapper = styled.div`
  width: 100%;
  order: 0;

  img {
    margin-bottom: 0;
    width: 100%;
  }

  ${mq.from.XSM`
    width: 220px;

    img {
      margin-bottom: 0;
      width: 220px !important;
    }
  `}

  ${mq.from.M`
    width: 235px;

    img {
      margin-bottom: 0;
      width: 236px !important;
    }
  `}
`
